import { FC } from "react";

import {
  loadingContainer,
  loadingDots,
  loadingDot,
  loadingDotSecond,
  loadingDotThird,
  loadingSubtext,
  loadingText,
} from "./CoralLoadingScreen.css";

export interface CoralLoadingScreenProps {
  isAuthenticating: boolean;
  isCoralLoading: boolean;
}

export const CoralLoadingDots: FC = () => (
  <div className={loadingDots}>
    <div className={loadingDot} />
    <div className={`${loadingDot} ${loadingDotSecond}`} />
    <div className={`${loadingDot} ${loadingDotThird}`} />
  </div>
);

/**
 * Modern loading screen component for Coral comments
 */
const CoralLoadingScreen: FC<CoralLoadingScreenProps> = ({
  isAuthenticating,
  isCoralLoading,
}) => {
  const getLoadingText = () => {
    // Default state: Coral isn't loaded yet
    if (isCoralLoading) {
      return {
        main: "Loading comments",
        sub: "Getting the conversation ready...",
      };
    }
    // Second state: Coral is loaded, now authenticating
    if (isAuthenticating) {
      return {
        main: "Logging in",
        sub: "Making sure you're you...",
      };
    }
    // Fallback state - show only animation, no text
    return {
      main: "",
      sub: "",
    };
  };

  const { main, sub } = getLoadingText();

  return (
    <div className={loadingContainer}>
      <CoralLoadingDots />
      {main && <div className={loadingText}>{main}</div>}
      {sub && <div className={loadingSubtext}>{sub}</div>}
    </div>
  );
};

export default CoralLoadingScreen;
